<div
  *transloco="let t"
  class="body text--hover text--hover-primary"
  (click)="initiateAssistanceInSelection()"
  dataAttribute
  componentName="header-user-info-assistance-link"
>
  {{ t('HEADER_USER_INFO.ASSISTANCE_IN_SELECTION') }}
</div>
